import { Icon } from "@circle-react/components/shared/Icon";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";
import type { UpgradePreview } from "@/react/types/Paywalls/Checkout/UpgradePreview";

const i18nRoot = "paywall_checkout.offer_page.upgrade";

interface UpgradePurchaseBannerProps {
  source: UpgradePreview["source"];
}

/**
 * Confirmation of the purchase the member just completed. It spans the full width
 * above the authored content, outside the themed region, so the admin's background
 * colour never applies to it.
 */
export const UpgradePurchaseBanner = ({
  source,
}: UpgradePurchaseBannerProps) => (
  <div
    className="flex w-full items-center justify-center gap-2 bg-success-light px-5 py-3"
    data-testid="upgrade-purchase-banner"
  >
    <Icon className="shrink-0 text-success" size={16} type="16-check-circle" />
    <Typography variant="body-sm">
      {t([i18nRoot, "purchase_banner"], {
        amount: source.display_amount,
        cadence: t([
          "paywalls.checkout.upgrade_preview",
          "billing_cadence",
          source.interval_type,
        ]),
        plan_name: source.name,
      })}
    </Typography>
  </div>
);
